export enum DocumentDownloadType {
    SignedDocumentsPacket = 'SignedDocumentsPacket',
    CertificateOfCompletion = 'CertificateOfCompletion',
    SignedDocumentsPacketWithCertificate = 'SignedDocumentsPacketWithCertificate'
}

